/*
 * Public API Surface of roles-permissions
 */

export * from './lib/roles-permissions.service';
export * from './lib/roles-permissions.module';
export * from './lib/roles-permissions.component';
export * from './lib/rest-api.token';
